import { IGetDroneHistoryResponse, IGetDroneOrderHistoryRequest, IGetDroneOrderHistoryResponse, IGetDroneMaintenanceResponse, IGetDronesResponse, IRegisterDroneRequest, IRegisterDroneResponse, IResetPartDroneRequest, IAdjustDroneMaintenanceRequest } from "./types";
import { baseDroneApi } from '@src/core/features';

export const droneFeatureApi = baseDroneApi.injectEndpoints({
  endpoints: (builder) => ({
    getDroneHistory: builder.query<IGetDroneHistoryResponse, number>({
      query: (droneId) => ({
        url: `/api/v1/drone/${droneId}/orders`,
        method: 'GET',
      }),
      providesTags: ['GetDroneHistory'],
    }),
    getDroneOrderHistory: builder.query<IGetDroneOrderHistoryResponse, IGetDroneOrderHistoryRequest>({
      query: ({ id, ...params }) => ({
        url: `/api/v1/drone/${id}/orders/paged`,
        method: 'GET',
        params,
      }),
      keepUnusedDataFor: 0,
    }),
    deleteDrone: builder.mutation<void, number>({
      query: (droneId) => ({
        url: `/api/v1/drone/archive/${droneId}`,
        method: 'PUT',
      }),
      invalidatesTags: ['GetDrones'],
    }),
    registerDrone: builder.mutation<IRegisterDroneResponse, IRegisterDroneRequest>({
      query: (data) => ({
        url: `/api/v1/drone/activate`,
        method: 'PUT',
        data
      }),
      invalidatesTags: ['GetDrones'],
    }),
    resetPartDrone: builder.mutation<void, IResetPartDroneRequest>({
      query: ({ id, part }) => ({
        url: `/api/v1/drone/${id}/${part}/reset`,
        method: 'PUT',
      }),
      invalidatesTags: (_, __, { id }) => ['GetDroneHistory', { type: 'GetDroneMaintenance', id }],
    }),
    flightSummaryById: builder.mutation<string, number>({
      query: (id) => ({
        url: `/api/v1/flight-summaries/${id}/download`,
        method: 'GET',
        responseType: 'blob',
      }),
      transformResponse: (blob: Blob) => {
        const fileBlob = new Blob([blob], { type: blob.type });
        return URL.createObjectURL(fileBlob);
      },
    }),
    flightSummaryAll: builder.mutation<string, void>({
      query: () => ({
        url: `/api/v1/flight-summaries/download`,
        method: 'GET',
        responseType: 'blob',
      }),
      transformResponse: (blob: Blob) => {
        const fileBlob = new Blob([blob], { type: blob.type });
        return URL.createObjectURL(fileBlob);
      },
    }),
    droneLogs: builder.mutation<string, string>({
      query: (droneSerial) => ({
        url: `/api/v1/drone-logs/download/${droneSerial}`,
        method: 'GET',
        responseType: 'blob',
      }),
      transformResponse: (blob: Blob) => {
        const fileBlob = new Blob([blob], { type: 'application/zip' });
        return URL.createObjectURL(fileBlob);
      },
    }),
    getDroneMaintenance: builder.query<IGetDroneMaintenanceResponse, number>({
      query: (droneId) => ({
        url: `/api/v1/drone/${droneId}/maintenance`,
        method: 'GET',
      }),
      providesTags: (_result, _error, droneId) => [{ type: 'GetDroneMaintenance', id: droneId }],
    }),
    adjustDroneMaintenance: builder.mutation<void, IAdjustDroneMaintenanceRequest>({
      query: ({ id, part, type, value }) => ({
        url: `/api/v1/drone/${id}/parts/adjust`,
        method: 'POST',
        data: { part, type, value },
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'GetDroneMaintenance', id }],
    }),
  }),
});

export const { 
  useGetDroneHistoryQuery, 
  useGetDroneMaintenanceQuery,
  useAdjustDroneMaintenanceMutation,
  useFlightSummaryAllMutation,
  useFlightSummaryByIdMutation,
  useGetDroneOrderHistoryQuery,

  useDeleteDroneMutation,
  useRegisterDroneMutation,
  useResetPartDroneMutation,
  useDroneLogsMutation,
} = droneFeatureApi;